import {ITableHeadCell, Order} from "../../interfaces/table-head";
import {visuallyHidden} from "@mui/utils";
import React from "react";
import {Box, Checkbox, TableHead, TableRow, TableSortLabel} from "@mui/material";
import {StyledDivDataTable} from "../../pages/user/list/styles";

export interface IPropsTableHead {
  order: Order;
  orderBy: string;
  /* eslint-disable no-unused-vars */
  onRequestSort: (property: string) => void;
  head : ITableHeadCell[]
}

export default function StyledTableHead(props: IPropsTableHead) {
  const createSortHandler = (property: string) => () => {
    props.onRequestSort(property);
  };

  return (
    <TableHead>
      <TableRow>
        <StyledDivDataTable width={5}><Checkbox/></StyledDivDataTable>
        {props.head.map((cell) => (
          <StyledDivDataTable key={cell.name} align={cell.align} width={cell.width}>
            <TableSortLabel
              active={props.orderBy === cell.name}
              direction={props.orderBy === cell.name ? props.order : "asc"}
              onClick={createSortHandler(cell.name)}
            >
              {props.orderBy === cell.name ? (
                <Box component="span" sx={visuallyHidden}>
                  {props.order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
              {cell.label}
            </TableSortLabel>
          </StyledDivDataTable>
        ))}
        <StyledDivDataTable align="center" width={8}> Opções </StyledDivDataTable>
      </TableRow>
    </TableHead>
  );
}
